// This file can be replaced during build by using the fileReplacements array.
// ng build --prod replaces environment.ts with environment.prod.ts.
// The list of file replacements can be found in angular.json.

export const environment = {
  production: false,
 //BaseUrl: "http://localhost:44877/api/" // Dev localhost
  BaseUrl: "https://kioskcustomerservice.baryons.net/api/"// Baryons staging
 //BaseUrl: "http://10.15.22.105:8080/api/" Alforsan UAT deployment
 //BaseUrl: "http://10.15.22.105:8888/api/" //Production from 14-Oct-2024

  //BaseUrl: "https://csuat.alforsan.ae/api/" // Alforsan UAT deployment from 28-Oct-2024
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as zone.run, zoneDelegate.invokeTask.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
